module.exports = __webpack_public_path__ + "img/organization-folded.b2c0fb49.svg";